/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, court: NonNullable<unknown> }} Next_AtInputs */

const th_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ถัดไป · ${i?.time} · ${i?.court}`)
};

const en_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next · ${i?.time} · ${i?.court}`)
};

const ja_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`次 · ${i?.time} · ${i?.court}`)
};

const zh_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一场 · ${i?.time} · ${i?.court}`)
};

const es_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Siguiente · ${i?.time} · ${i?.court}`)
};

const pt_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo · ${i?.time} · ${i?.court}`)
};

const id_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berikutnya · ${i?.time} · ${i?.court}`)
};

const fr_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suivant · ${i?.time} · ${i?.court}`)
};

const tl_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Susunod · ${i?.time} · ${i?.court}`)
};

const vi_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kế tiếp · ${i?.time} · ${i?.court}`)
};

const ko_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다음 · ${i?.time} · ${i?.court}`)
};

const de_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als Nächstes · ${i?.time} · ${i?.court}`)
};

const ru_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Далее · ${i?.time} · ${i?.court}`)
};

const tr_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sırada · ${i?.time} · ${i?.court}`)
};

const it_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossima · ${i?.time} · ${i?.court}`)
};

const pl_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Następny · ${i?.time} · ${i?.court}`)
};

const uk_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Далі · ${i?.time} · ${i?.court}`)
};

const hi_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अगला · ${i?.time} · ${i?.court}`)
};

const ar_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`التالي · ${i?.time} · ${i?.court}`)
};

const ms_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seterusnya · ${i?.time} · ${i?.court}`)
};

const bn_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`পরবর্তী · ${i?.time} · ${i?.court}`)
};

const zh_tw2_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一場 · ${i?.time} · ${i?.court}`)
};

const zh_hk2_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一場 · ${i?.time} · ${i?.court}`)
};

const ur_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اگلا · ${i?.time} · ${i?.court}`)
};

const fa_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بعدی · ${i?.time} · ${i?.court}`)
};

const sw_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inayofuata · ${i?.time} · ${i?.court}`)
};

const nl_next_at = /** @type {(inputs: Next_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hierna · ${i?.time} · ${i?.court}`)
};

/**
* | output |
* | --- |
* | "Next · {time} · {court}" |
*
* @param {Next_AtInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const next_at = /** @type {((inputs: Next_AtInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_AtInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_next_at(inputs)
	if (locale === "ja") return ja_next_at(inputs)
	if (locale === "zh") return zh_next_at(inputs)
	if (locale === "es") return es_next_at(inputs)
	if (locale === "pt") return pt_next_at(inputs)
	if (locale === "id") return id_next_at(inputs)
	if (locale === "fr") return fr_next_at(inputs)
	if (locale === "tl") return tl_next_at(inputs)
	if (locale === "vi") return vi_next_at(inputs)
	if (locale === "ko") return ko_next_at(inputs)
	if (locale === "de") return de_next_at(inputs)
	if (locale === "ru") return ru_next_at(inputs)
	if (locale === "tr") return tr_next_at(inputs)
	if (locale === "it") return it_next_at(inputs)
	if (locale === "pl") return pl_next_at(inputs)
	if (locale === "uk") return uk_next_at(inputs)
	if (locale === "hi") return hi_next_at(inputs)
	if (locale === "ar") return ar_next_at(inputs)
	if (locale === "ms") return ms_next_at(inputs)
	if (locale === "bn") return bn_next_at(inputs)
	if (locale === "zh-TW") return zh_tw2_next_at(inputs)
	if (locale === "zh-HK") return zh_hk2_next_at(inputs)
	if (locale === "ur") return ur_next_at(inputs)
	if (locale === "fa") return fa_next_at(inputs)
	if (locale === "sw") return sw_next_at(inputs)
	if (locale === "nl") return nl_next_at(inputs)
	return en_next_at(inputs)
});